import React, {useEffect} from 'react'
import Loader from 'react-loader';

function Loaders(props) {

  useEffect(() => {
    
  }, [props.loads]);
  return (
    <div>
		 <Loader
					loaded={props.loads}
					lines={10}
					length={20}
					width={10}
					radius={15}
					corners={1}
					rotate={0}
					direction={1}
					color='#000'
					speed={1}
					trail={60}
					shadow={false}
					hwaccel={false}
					className='spinner'
					zIndex={1000}
					top='45%'
					left='52%'
					scale={1.0}
					loadedClassName='loadedContent'
				/>
    </div>
  )
}

export default Loaders